"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToXPUB = convertToXPUB;

var _unchainedBitcoin = require("unchained-bitcoin");

var _types = require("./types");

/**
 * This module defines helper functions for extended public key conversion.
 *
 * @module conversion
 */

/**
 * Convert any extended public key (ypub, zpub, etc.) to the XPUB format
 * defined in BIP44. Resulting key will be an xpub (mainnet) or a tpub
 * (testnet).
 *
 * @param  {string} extPubKey - the extended public key to convert
 * @param  {string} network - the network to convert to (MAINNET or TESTNET)
 *
 * @returns {(string|object)} converted extended public key or error object
 * with the failed key and error message
 */
function convertToXPUB(extPubKey, network) {
  var targetPrefix = network === _unchainedBitcoin.NETWORKS.MAINNET ? _types.TYPE.XPUB : _types.TYPE.TPUB;
  return (0, _unchainedBitcoin.convertExtendedPublicKey)(extPubKey, targetPrefix);
}